import { clsx } from '@appvantageasia/core-utils';
import { Settings } from 'lucide-react';
import Avatar from '@/components/blocks/Avatar';
import { useUserSession } from '@/contexts/UserSession';

interface FooterMenuProps {
    index: number;
    activeIndex: number | null;
    onOpenSetting: () => void;
}
const FooterMenu = ({ index, activeIndex, onOpenSetting }: FooterMenuProps) => {
    const { user } = useUserSession();

    return (
        <div className="flex flex-col items-center justify-center space-y-5 pb-6">
            {index > -1 && (
                <button
                    onClick={onOpenSetting}
                    data-cy="settingButton"
                    className={clsx(
                        'text-default-500 hover:bg-primary hover:text-primary-foreground mx-auto flex h-11 w-11 cursor-pointer items-center justify-center rounded-md transition-all duration-200',
                        {
                            'bg-primary text-primary-foreground': index === activeIndex,
                        }
                    )}
                >
                    <Settings className="h-5 w-5" />
                </button>
            )}

            <Avatar name={user?.name} />
        </div>
    );
};
export default FooterMenu;
